import {useEffect, useState, useRef} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
// -
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import axiApi from "ApiCaller";
import ButtonsActions from "views/utils/buttonsActions";
import navs from "./navs";
import TableServers from "./servers/TableServers";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import NoConfigsData from "./configs/NoConfigsData";

const ViewServers = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tags");
    const navigate = useNavigate();
    document.title = _Tr("labels.networks");

    const bread = [
        {
            name: _Tr("labels.advanced"),
            url: "/advanced/",
            current: false,
        },
        {name: document.title, current: true},
    ];

    const buttonsAct = new ButtonsActions();
    const [buttonsTB, setButtonsTB] = useState({
        ...buttonsAct,
        title: document.title,
    });
    const AlertQuestion = new SwalAlertChoice({
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const items = useRef(new ItemsModel());

    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShow, setItemsShow] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const [item, setItem] = useState({});

    const headersTable = [
        {name: (_Tt("common.name")), attr: 0, direction: "asc", active: false},
        {name: (_Tt("common.description")), attr: 1, direction: "asc", active: false},
        {name: (_Tt("common.model")), attr: 2, direction: "asc", active: false},
    ];

    useEffect(() => {
        let buttons = {...buttonsAct};
        buttons.title = document.title;
        buttons.add.active = true;
        buttons.add.disabled = true;
        buttons.add.onClick = () => {
            navigate("/advanced/network/add/");
        };
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchPostData();
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchPostData();
        };
        filters.current.filter = () => {
            pagerModelRef.current.paging.page = 1;
            fetchPostData();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = {};
        fetchGetData();
    }, []);

    const fetchGetData = async () => {
        setIsLoading(true);
        const resp = await axiApi.get("/api/devices/network/servers/");
        if (resp.data) {
            pagerModelRef.current.active = resp.data.items.length > 0;
            items.current.showed = [...resp.data.items];
            items.current.clearChosen();
            setItemsShow([...items.current.showed]);
            pagerModelRef.current.paging.setPager(resp.data);
            setButtonsTB((prevButtons) => ({
                ...prevButtons,
                add: {
                    ...prevButtons.add,
                    disabled: resp.data.models.length === 0,
                },
            }));
        }
        setIsLoading(false);
    };

    const fetchPostData = async () => {
        setIsLoading(true);
        const resp = await axiApi.post(
            "/api/devices/network/servers/",
            filters.current.chosen,
            {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            }
        );
        if (resp.data.status) {
            items.current.setShowed(resp.data.items);
            setItemsShow([...resp.data.items]);
            pagerModelRef.current.paging.setPager(resp.data);
            setButtonsTB((prevButtons) => ({
                ...prevButtons,
                add: {
                    ...prevButtons.add,
                },
            }));
        } else {
            console.error("Error en alertSetup.api()");
            Alert.warning(
                "Error en el servicio",
                "No se han podido recuperar las alertas"
            );
        }
        setIsLoading(false);
    };

    const onClickEdit = (e) => {
        if (!items.current.chosen.length || items.current.chosen.length > 1) {
            return false;
        }
        let chosen = items.current.chosen[0];
        navigate(`/advanced/network/${chosen}/`);
    };

    const onClickDelete = (e) => {
        AlertQuestion.fire("Se eliminaran", "Todos los seleccionados").then((r) => {
            if (r.isConfirmed) {
                let ids = items.current.getChosenIds();

                axiApi
                    .delete("/api/devices/network/servers/", {
                        data: {ids: ids},
                    })
                    .then((r) => {
                        if (r.data.status) {
                            Alert.success(
                                "Confirmado",
                                "Se han eliminado correctamente"
                            );
                            // Filtra los items eliminados
                            items.current.showed = items.current.showed.filter(
                                (item) => !ids.includes(item.id)
                            );
                            items.current.clearChosen();
                            let buttons = {...buttonsTB};
                            buttons.delete.disabled = true;
                            buttons.edit.disabled = true;
                            setButtonsTB(buttons);
                            setItemsShow([...items.current.showed]);
                        }
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination
                pagerModel={pagerModelRef.current}
                stickyTopValue="125px"
                chosen={items.current.chosen}
            />
            <LoaderSpinner isLoading={isLoading}>
                <NoConfigsData items={itemsShow}>
                    <TableServers
                        items={items}
                        itemsShow={itemsShow}
                        buttonsTB={buttonsTB}
                        setButtonsTB={setButtonsTB}
                        checkAll={checkedAll}
                        setCheckAll={setCheckedAll}
                        orderingRef={orderingRef}
                    />
                </NoConfigsData>
            </LoaderSpinner>
        </>
    );
};
export default ViewServers;
